import { defineMessages } from 'react-intl';

export default defineMessages({
    currentPremium: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.Current Premium',
        defaultMessage: 'Adjusted premium',
    },
    eligiblePremium: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.Eligible Premium',
        defaultMessage: 'Eligible Flex Premium',
    },
    maxReduction: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.Max Flex Allowance',
        defaultMessage: 'Max dollar discount',
    },
    flexReason: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.Flex reason',
        defaultMessage: 'Flex reason',
    },
    flexReasonDescription: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.Flex reason description',
        defaultMessage: 'Flex reason description',
    },
    inEligibleFlexPremium: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.ineligible for the flex program',
        defaultMessage: 'Ineligible for the flex program',
    },
    flexNotApplicable: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.Not applicable',
        defaultMessage: 'Not applicable',
    },
    flexErrorsMessageYes: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.flexErrorsMessage',
        defaultMessage: '{riskType} is ineligible for the flex program based on:',
    },
    flexErrorsMessageNo: {
        id: 'wmic-pe-capability-gateway-common-react.WMICIterableFlexRiskItem.flexErrorsMessageNo',
        defaultMessage: '{riskType} is ineligible for the flex program.',
    },
    estimatedTargetedPremium: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Estimated target premium',
        defaultMessage: 'Estimated target premium amount',
    },
    basePremium: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Base premium',
        defaultMessage: 'Base premium',
    },
    maximumFlexPercentage: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Maximum flex percentage',
        defaultMessage: 'Max percentage discount',
    },
    flexDollarAmount: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Flex dollar amount',
        defaultMessage: 'Flex Dollar Amount',
    },
    flexPercentage: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Flex percentage',
        defaultMessage: 'Flex Percentage',
    },
    fetchingTitle: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Fetching Title',
        defaultMessage: 'Fetching Flex Details...',
    },
    errorRecalculatingFlexFields: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Error Recalculating Flex Fields',
        defaultMessage: 'Error Recalculating Flex Fields.',
    },
    estimateButton: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Estimate',
        defaultMessage: 'Estimate',
    },
    flexCalculatorHeader: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Flex Estimate Calculator',
        defaultMessage: 'Flex Estimate Calculator',
    },
    flexCalculatorBody: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.To calculate the target premium, enter either the percentage or dollar amount below, then click Estimate.',
        defaultMessage: 'To calculate the target premium, enter either the percentage or dollar amount below, then click Estimate.',
    },
    maxDiscountFlexPercentage: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Max discount Flex Percentage',
        defaultMessage: 'Max discount {percentage}',
    },
    maxDiscountFlexDollarAmount: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexProgramComponent.WMICIterableFlexRiskItem.WMICIterableFlexRiskItem.Max discount Flex Dollar Amount',
        defaultMessage: 'Max discount {dollarAmount}',
    }
});
